module.exports = __webpack_public_path__ + "img/ad-banner.6ed5efda.svg";